import script from "./base-switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-switch.vue?vue&type=script&setup=true&lang=ts"

import "./base-switch.vue?vue&type=style&index=0&id=0e5d9f16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e5d9f16"]])

export default __exports__